export default __webpack_public_path__ + "static/media/selectDestinationCaraiva.a178b250.svg";